import { render } from "./GetNegativeLots.vue?vue&type=template&id=1bbfcd18"
import script from "./GetNegativeLots.vue?vue&type=script&lang=js"
export * from "./GetNegativeLots.vue?vue&type=script&lang=js"
script.render = render

export default script